export { getDeviceType } from './getDeviceType';
export { isIOSInAppBrowser } from './isIOSInAppBrowser';
